/* eslint-disable no-param-reassign */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-unused-expressions */
import Axios from 'axios';
import bytes from 'bytes';
import {
  CONTEXT,
  APP_VERSION,
  APP_VERSION_D,
  APP_VERSION_CODE,
  APP_VERSION_CODE_D,
  REGISTER_URL,
  REPORT_LOG_URL,
} from '../config';
import { cacheKeys, SCROLL_PAGE } from '../constants/storageKeys';
import { PCStoreJsBridge } from '../nativeapi';

let regTokenStep = -1; // -1:初始值 0：正在请求 1：请求成功

// 请求开始的处理
Axios.interceptors.request.use(config => {
  // 请求REQUEST_ID url timestamp 上报
  config.REQUEST_ID = Date.now();
  return config;
});

// 请求结束的处理
Axios.interceptors.response.use(
  response => {
    const { config } = response;
    // 请求时长>200ms 上报这个桩
    if (Date.now() - config.REQUEST_ID > 300) {
      logging({
        category: 'M',
        action: 'End_api',
        label: '',
        param2: {
          service: config.url,
          status: 1,
          time: Date.now() - config.REQUEST_ID,
        },
      });
    }
    response.status === 200
      ? logNative(`http请求 结束请求：${config.url}`, { status: response.status }, false, true)
      : logNative(`http请求 结束请求：${config.url}`, { status: response.status }, true);

    if (response.data && response.data.status && response.data.status.toString() === '502') {
      // token 过期 自动注册 Token 重新请求
      if (regTokenStep === -1) {
        regTokenStep = 0;
        const regInfo = localStorage.getItem(cacheKeys.LOCALMACHINE_INFO);
        registerToken(JSON.parse(regInfo))
          .then(token => {
            regTokenStep = 1;
            response.config.headers.token = token;
            return Axios.request(response.config);
          })
          .catch(() => {
            regTokenStep = -1;
          });
      }

      if (regTokenStep === 0) {
        return Axios.request(response.config);
      }

      if (regTokenStep === 1) {
        const token = localStorage.getItem(cacheKeys.REGISTER_TOKEN);
        response.config.headers.token = token;
        return Axios.request(response.config);
      }
    }
    return response;
  },
  error => {
    const { config } = error.response;
    // 请求时长>200ms 上报这个桩
    if (Date.now() - config.REQUEST_ID > 300) {
      logging({
        category: 'M',
        action: 'End_api',
        label: '',
        param2: {
          service: config.url,
          status: 2,
          time: Date.now() - config.REQUEST_ID,
          mes: error.message,
        },
      });
    }

    // 登录信息userToken过期处理401错误
    if (error.response.status === 401) {
      if (regTokenStep === -1) {
        regTokenStep = 0;
        const userTokenParam = { data: {} };
        userTokenParam.data[cacheKeys.X_LESYNC_TOKEN] =
          localStorage.getItem(cacheKeys.X_LESYNC_TOKEN) || '';
        // 重新获取更新的userToken
        return PCStoreJsBridge.getUserTokenInfo(userTokenParam)
          .then(res => {
            regTokenStep = 1;
            if (res && res[cacheKeys.X_LESYNC_TOKEN]) {
              const userToken = res[cacheKeys.X_LESYNC_TOKEN];
              // 更改请求header中的ltoken，并且更改localStorage的X_LESYNC_TOKEN信息
              config.headers.ltoken = userToken;
              localStorage.setItem(cacheKeys.X_LESYNC_TOKEN, userToken);
            }
            const instance = Axios.create();
            return instance(config);
            // return Axios.request(error.response.config);
          })
          .catch(e => {
            logNative(`http请求 遇到401错误但是重新获取userToken失败 ${e}`, e);
            regTokenStep = -1;
          });
      }
    }
    return Promise.reject(
      new Error(`still get token failed after retry 3 times ! fatal error=${error.message} `),
    );
  },
);

export async function loggingADX(urlArr = []) {
  urlArr.forEach(url => {
    Axios.get(url.toString())
      .then(res => {
        logNative(
          `ADX 打桩请求结束 地址：${url}, 请求结果：${JSON.stringify(res)}`,
          {},
          true,
          true,
        );
      })
      .catch(err => {
        logNative(`ADX 打桩请求错误 地址：${url}, 请求结果：${err}`, {});
        throw err;
      });
  });
}

export function registerToken(registryInfo) {
  // 注册API接口 获取 Token 保存到 localStorage
  return Axios.post(REGISTER_URL, {
    ch: APP_VERSION,
    mac: registryInfo.MAC,
    mt: registryInfo.MT,
    os: registryInfo.OS,
    osBit: registryInfo.OSbit,
    sn: registryInfo.SN,
    uuid: registryInfo.UUID,
  })
    .then(res => {
      if (res.data.data) {
        localStorage.setItem(cacheKeys.REGISTER_TOKEN, res.data.data);
        return Promise.resolve(res.data.data);
      }
      throw new Error('register token  failed');
    })
    .catch(err => {
      throw err;
    });
}

export async function createAxios(need) {
  let token = localStorage.getItem(cacheKeys.REGISTER_TOKEN);
  const machineInfo = localStorage.getItem(cacheKeys.LOCALMACHINE_INFO);
  if (!token) {
    if (machineInfo) {
      token = await registerToken(JSON.parse(machineInfo));
      localStorage.setItem(cacheKeys.REGISTER_TOKEN, token);
    } else {
      const regInfo = await PCStoreJsBridge.getLocalMachineInfo();
      token = await registerToken(regInfo);
    }
  }
  // http header 中放入vt参数
  let vt = localStorage.getItem(cacheKeys.IS_VT_ENABLE);
  if (vt === null) {
    const isVTEnable = await PCStoreJsBridge.getIsVTEabled();
    vt = isVTEnable.vt ? '1' : '0';
    localStorage.setItem(cacheKeys.IS_VT_ENABLE, vt);
  }
  // http header 中放入user token(即：ltoken)参数
  if (need === 'isNeedUser') {
    const userToken = await getUserToken();
    Axios.defaults.headers.common.ltoken = userToken;
  }
  Axios.defaults.headers.common.token = token;
  Axios.defaults.headers.common.vt = vt;
  Axios.defaults.headers.common.productCode = 2;
  // h5支持的功能（例如：1011）
  // 第一位指：表示5.5能力（是否支持专题）
  // 第二位指：表示6.0能力（card增加专题list card，和商城 card）
  // 第三位指：表示6.5能力（card增加 商城弹框 card）
  // 第四位指：表示7.1能力（banner支持OtherPage）
  Axios.defaults.headers.common.h5need = '1111';
  return Axios;
}

export async function getUserToken() {
  let userToken = '';
  userToken = localStorage.getItem(cacheKeys.X_LESYNC_TOKEN) || '';

  if (!userToken || userToken === 'undefined') {
    const res = await PCStoreJsBridge.getUserTokenInfo();
    if (res && res[cacheKeys.X_LESYNC_TOKEN]) {
      userToken = res[cacheKeys.X_LESYNC_TOKEN] || '';
      localStorage.setItem(cacheKeys.X_LESYNC_TOKEN, userToken);
    }
  }
  return userToken;
}

export function imgLocalUrl(url) {
  return `http://pcm/file:///${encodeURIComponent(url)}`;
}

export function sumAll(arr) {
  let sum = 0;
  let i = 0;
  for (i; i < arr.length; i += 1) {
    sum += Number(arr[i].estimateSize);
  }
  return bytes(sum, { unitSeparator: ' ' });
}

// native安装的 key需要转成首字母大写，不然就没法下载
export function capitalizeObj(obj) {
  if (typeof obj !== 'object') {
    return obj;
  }
  const capitalObj = {};
  for (const orgKey in obj) {
    const key = orgKey.charAt(0).toUpperCase() + orgKey.slice(1);
    if (!capitalObj[key] && obj[orgKey]) {
      capitalObj[key] = obj[orgKey];
    }
    // capitalObj[key] = obj[orgKey];
  }
  return capitalObj;
}

// 首字母转小写
export function camelizeObj(obj) {
  if (typeof obj !== 'object') {
    return obj;
  }
  const camelizeRet = {};
  for (const orgKey in obj) {
    const key = orgKey.charAt(0).toLowerCase() + orgKey.slice(1);
    if (!camelizeRet[key] && obj[orgKey]) {
      camelizeRet[key] = obj[orgKey];
    }
    // camelizeRet[key] = obj[orgKey];
  }
  return camelizeRet;
}

export function changeClass(el, newClassName, oldClassName) {
  oldClassName && removeClass(el, oldClassName);
  newClassName && addClass(el, newClassName);
}

export function hasClass(el, className) {
  if (el) {
    const reg = new RegExp(`(^|\\s)${className}(\\s|$)`);
    return reg.test(el.className);
  }
  return false;
}

export function removeClass(el, className) {
  if (!hasClass(el, className)) {
    return;
  }
  const newClass = el.className.split(' ');
  newClass.splice(newClass.indexOf(className), 1);
  el.className = newClass.join(' ');
}

export function addClass(el, className) {
  if (hasClass(el, className)) {
    return;
  }
  const newClass = el.className.split(' ');
  newClass.push(className);
  el.className = newClass.join(' ');
}

export function getQueryString(key, url) {
  url = url || window.location.search;
  const reg = new RegExp(`(^|&)${key}=([^&]*)(&|$)`);
  const r = url.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return null;
}
export function getQueryString2(key, url) {
  url = url || window.location.search;
  const reg = new RegExp(`(^|&)${key}=([^&]*)(&|$)`);
  const r = url.substr(1).match(reg);
  if (r != null) {
    return r[2];
  }
  return null;
}

export function getParamString(key, string) {
  const reg = new RegExp(`(^|#)${key}=([^#]*)(#|$)`);
  const r = string.substr(1).match(reg);
  if (r != null) {
    const cont = decodeURIComponent(r[2]);
    if (cont.indexOf(' ') > -1) {
      return cont.split(' ')[0];
    }
    return cont;
  }
  return null;
}

export function getParamString2(key, string) {
  const reg = new RegExp(`(^|#)${key}=([^#]*)(#|$)`);
  const r = string.substr(1).match(reg);
  if (r != null) {
    const cont = r[2];
    if (cont.indexOf(' ') > -1) {
      return cont.split(' ')[0];
    }
    return cont;
  }
}

/**
 * 只是生成内部的跳转url
 * @param {*} info
 */
export function getUrlByTargetContent(info) {
  let url = `${CONTEXT}/recommend`;
  // 应用详情页面
  if (info.targetType === '1' && info.appInfo) {
    if (info.appInfo.androidType === '1') {
      url = `${CONTEXT}/adetail/${info.appInfo.packageName}/${info.appInfo.versionCode}/${info
        .appInfo.bizInfo || '{}'}`;
    } else {
      url = `${CONTEXT}/detail/soft/${info.appInfo.softID || ''}/${info.appInfo.bizInfo || '{}'}`;
    }
  }

  // 专题详情页面
  if (info.targetType === '3' && info.ztId) {
    url = `${CONTEXT}/special?ztId=${info.ztId}&bannerId=${info.pageCardContentId || ''}`;
  }

  // 仅仅处理iframe其他页面，7.1新增
  if (info.targetType === '12' && info.targetContent) {
    let targetContent = {};
    if (typeof info.targetContent === 'string') {
      try {
        targetContent = JSON.parse(info.targetContent);
      } catch (error) {
        logNative(`分析URL getUrlByTargetContent JSON解析错误:${error}`, error);
      }
    } else {
      targetContent = info.targetContent;
    }
    url = `${CONTEXT}/otherpage?pageUrl=${encodeURIComponent(
      targetContent.url,
    )}&bizInfo=${encodeURIComponent('{}')}`;
  }

  // 其他页面  6.5新增
  if (info.targetType === '11' && info.targetContent) {
    let targetContent = {};
    if (typeof info.targetContent === 'string') {
      try {
        targetContent = JSON.parse(info.targetContent);
      } catch (error) {
        logNative(`分析URL getUrlByTargetContent JSON解析错误:${error}`, error);
      }
    } else {
      targetContent = info.targetContent;
    }
    // 游戏菜单现在是动态配置了，不能硬编码了
    if (/^game\//.test(targetContent.targetPage)) {
      url = `${CONTEXT}/${targetContent.targetPage}`;

      if (targetContent.targetPage === 'game/gameLibrary') {
        url += `?code=${targetContent.code || ''}&childCode=${targetContent.childCode || ''}`;
      } else if (targetContent.targetPage === 'game/gameRank' && targetContent.code) {
        url += `/${targetContent.code}`;
      }
      return url;
    }
    switch (targetContent.targetPage) {
      case 'recommend':
        url = `${CONTEXT}/recommend`;
        break;
      // case 'education':
      //   url = `${CONTEXT}/education`;
      //   break;
      case 'edurecommend':
        url = `${CONTEXT}/education/recommend`;
        break;
      case 'educategory':
        url = `${CONTEXT}/education/category?gradeId=${targetContent.gradeId}&subjectId=${targetContent.subjectId}&phaseId=${targetContent.phaseId}`;
        break;
      case 'edumine':
        url = `${CONTEXT}/education/mine?tag=${targetContent.tag}`;
        break;
      case 'edudetail':
        url = `${CONTEXT}/edudetail?courseId=${targetContent.courseId}&studyState=${targetContent.studyState}&bizInfo=${targetContent.bizInfo}`;
        break;
      case 'work':
        url = `${CONTEXT}/work`;
        break;
      case 'wprecommend':
        url = `${CONTEXT}/wprecommend`;
        break;
      case 'wpauthordetail':
        url = `${CONTEXT}/wpauthordetail?authorId=${targetContent.authorId}`;
        break;
      case 'wprank':
        url = `${CONTEXT}/wprank?code=${targetContent.rankId}`;
        break;
      case 'wpdetail':
        url = `${CONTEXT}/wpdetail?wallpaperId=${targetContent.wallpaperId}&pageSource=recommend`;
        break;
      case 'wpauthorlist':
        url = `${CONTEXT}/wpauthorlist`;
        break;
      case 'wpcategory':
        url = `${CONTEXT}/wpcategory?classId=${targetContent.classId ||
          ''}&tagId=${targetContent.tagId || ''}&colorId=${targetContent.colorId ||
          ''}&wpSource=lookaround`;
        break;
      case 'softrank':
        url = `${CONTEXT}/rankmore?code=${targetContent.code}`;
        break;
      case 'speciallist':
        url = `${CONTEXT}/speciallist?pageType=${'recommend'}&ztType=${targetContent.ztType}&tag=${
          targetContent.tag
        }`;
        break;
      case 'special':
        url = `${CONTEXT}/special?ztId=${
          targetContent.ztId
        }&bannerId=${targetContent.pageCardContentId || ''}`;
        break;
      case 'category':
        url = `${CONTEXT}/category?code=${targetContent.code ||
          ''}&classId=${targetContent.classId || ''}&tagId=${targetContent.tagId || ''}`;
        break;
      case 'otherpage':
        url = `${CONTEXT}/otherpage?url=${targetContent.code ||
          ''}&classId=${targetContent.classId || ''}&tagId=${targetContent.tagId || ''}`;
        break;
      default:
        url = `${CONTEXT}/recommend`;
        break;
    }
  }

  return url;
}

export function addCookie(sName, sValue, day) {
  const expireDate = new Date();
  expireDate.setDate(expireDate.getDate() + day);
  // 设置失效时间
  document.cookie = `${escape(sName)}=${escape(sValue)};expires=${expireDate.toGMTString()}`;
}

export function sortSoftsByLocalSoftInit(softs, localSoftsInit) {
  const softArr = [];
  softs.forEach((item, index) => {
    const found = localSoftsInit.find(
      soft =>
        (soft.androidType !== '1' &&
          (soft.softID === item.softID || soft.SoftID === item.softID)) ||
        (soft.androidType === '1' && soft.packageName === item.packageName),
    );
    softArr.push({ ...item, sortByLocalSoftsInit: found ? 100000 + index : index });
  });
  softArr.sort((a, b) => {
    return a.sortByLocalSoftsInit - b.sortByLocalSoftsInit;
  });
  return softArr;
}

export function byteLength(str) {
  let count = 0;
  for (let i = 0; i < str.length; i += 1) {
    if (str.charCodeAt(i) > 255) {
      count += 2;
    } else {
      count += 1;
    }
  }
  return count;
}

export function scrollingContainerToTop() {
  const contentElement = document.getElementById('container_content').scrollTo(0, 0);
}

export function scrollingContainer(contDom, history) {
  if (contDom) {
    const scrollPageStr = sessionStorage.getItem(SCROLL_PAGE) || '{}';
    // const pageKey = `${location.pathname}${location.search}`;
    const pageKey = `${window.location.pathname}${window.location.search}`;
    try {
      const scrollPage = JSON.parse(scrollPageStr);
      const scrollPageTop = scrollPage[pageKey] || 0;
      const elCHeight = (contDom && contDom.firstChild && contDom.firstChild.scrollHeight) || 0;

      // 当子元素高度elCHeight > 存储的滚动高度scrollPageTop;
      // 且元素滚动高度elScrollTop !== 将要设置的高度时;
      // 屏蔽掉game的页面;
      if (
        scrollPageTop &&
        scrollPageTop !== parseInt(contDom.scrollTop) &&
        elCHeight > scrollPageTop &&
        history.action === 'POP' &&
        pageKey.indexOf('Game') === -1
      ) {
        logNative(`回退, 滚动页面到指定位置 `, {
          action: history.action,
          pageKey,
          scrollPageTop,
          scrollTop: parseInt(contDom.scrollTop),
          elCHeight,
        });
        contDom.scrollTo(0, scrollPageTop - 220);
      } else {
        // contEl.scrollTo(0, 0);
      }
    } catch (error) {
      logNative('Scroll Page JSON error', error);
    }
  }
}

export function scrollingDom(dom, toNum = 0, speed = 5) {
  if (!dom) {
    return;
  }
  !window.requestAnimationFrame && this.initRequestAnimationFrame();
  let scroll = null;
  const fromNum = dom.scrollTop;
  const toNumMax = dom.scrollHeight;
  if (toNum < 0) {
    toNum = 0;
  }
  if (toNumMax < toNum) {
    toNum = toNumMax;
  }
  if (fromNum > toNum) {
    // 向上移动
    scroll = () => {
      const index = window.requestAnimationFrame(() => {
        window.cancelAnimationFrame(index);
        if (dom.scrollTop > toNum) {
          scroll();
          dom.scrollTop -= speed;
        }
      });
    };
  } else {
    // 向下移动
    scroll = () => {
      const index = window.requestAnimationFrame(() => {
        window.cancelAnimationFrame(index);
        if (dom.scrollTop + speed < toNum) {
          scroll();
          dom.scrollTop += speed;
        }
      });
    };
  }
  scroll();
}

export function initRequestAnimationFrame() {
  if (window.requestAnimationFrame) {
    return;
  }
  if (window.webkitRequestAnimationFrame) {
    window.requestAnimationFrame = window.webkitRequestAnimationFrame;
    window.cancelAnimationFrame = window.webkitCancelAnimationFrame
      ? window.webkitCancelAnimationFrame
      : window.webkitCancelRequestAnimationFrame;
    return;
  }
  if (window.mozRequestAnimationFrame) {
    window.requestAnimationFrame = window.mozRequestAnimationFrame;
    window.cancelAnimationFrame = window.mozCancelAnimationFrame
      ? window.mozCancelAnimationFrame
      : window.mozCancelRequestAnimationFrame;
    return;
  }
  let lastTime = 0;
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function(callback) {
      const currTime = new Date().getTime();
      const timeToCall = Math.max(0, 16 - (currTime - lastTime));
      const id = window.setTimeout(function() {
        callback(currTime + timeToCall);
      }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }
  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function(id) {
      clearTimeout(id);
    };
  }
}

export function clientOS() {
  const sUserAgent = navigator.userAgent;
  const isWinPlatform = navigator.platform === 'Win32' || navigator.platform === 'Windows';
  const isMac =
    navigator.platform === 'Mac68K' ||
    navigator.platform === 'MacPPC' ||
    navigator.platform === 'Macintosh' ||
    navigator.platform === 'MacIntel';
  if (isMac) return 'Mac';
  const isUnix = navigator.platform === 'X11' && !isWinPlatform && !isMac;
  if (isUnix) return 'Unix';
  const isLinux = String(navigator.platform).indexOf('Linux') > -1;
  if (isLinux) return 'Linux';
  if (isWinPlatform) {
    const isWin2K =
      sUserAgent.indexOf('Windows NT 5.0') > -1 || sUserAgent.indexOf('Windows 2000') > -1;
    if (isWin2K) return 'win2000';
    const isWinXP =
      sUserAgent.indexOf('Windows NT 5.1') > -1 || sUserAgent.indexOf('Windows XP') > -1;
    if (isWinXP) return 'winxp';
    let isWin =
      sUserAgent.indexOf('Windows NT 5.2') > -1 || sUserAgent.indexOf('Windows 2003') > -1;
    if (isWin) return 'win2003';
    isWin = sUserAgent.indexOf('Windows NT 6.0') > -1 || sUserAgent.indexOf('Windows Vista') > -1;
    if (isWin) return 'vista';
    isWin = sUserAgent.indexOf('Windows NT 6.1') > -1 || sUserAgent.indexOf('Windows 7') > -1;
    if (isWin) return 'win7';
    isWin = sUserAgent.indexOf('Windows NT 8.1') > -1 || sUserAgent.indexOf('Windows 8') > -1;
    if (isWin) return 'win8';
    isWin = sUserAgent.indexOf('Windows NT 10.0') > -1 || sUserAgent.indexOf('Windows 10') > -1;
    if (isWin) return 'win10';
  }
  return 'None';
}

export function assignParam1(param1 = {}, machineInfos = {}, commandLine = '') {
  const startInfo = JSON.parse(localStorage.getItem(cacheKeys.START_INFO) || '{}') || {};
  const userInfo = JSON.parse(localStorage.getItem(cacheKeys.USER_INFO) || '{}') || {};
  // 拿取machineInfo信息
  let machineInfo = JSON.parse(localStorage.getItem(cacheKeys.LOCALMACHINE_INFO) || '{}');
  machineInfo = Object.assign(machineInfo, param1);
  machineInfo = Object.assign(machineInfo, machineInfos);
  const date = new Date();
  const logtime = `${date.getFullYear()}-${date.getMonth() +
    1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;

  const param1New = {
    app_channel: startInfo.leas_channel || '',
    deviceid: machineInfo.MAC || machineInfo.SN || machineInfo.MACCABLE || machineInfo.UUID || '', //  默认采集设备id
    device_model: machineInfo.MT, //  设备型号
    device_type:
      (machineInfo.MAC && 'MAC') ||
      (machineInfo.SN && 'SN') ||
      (machineInfo.MACCABLE && 'MACCABLE') ||
      (machineInfo.UUID && 'UUID') ||
      '', // 设备号类型   设备号类型     否 设备类型：目前日志MACWIF...
    UUID: machineInfo.UUID,
    language: '', //  用户本机设置语言
    lenovoid: userInfo.uid || userInfo.lid || '', //  登录用户账号
    logtime, // 时间
    manufacturer: '', //  厂家
    network_type: '', //  网络类型
    origin: commandLine, //  来源    入口来源
    os_version: `${machineInfo.OS} ${machineInfo.OSbit}`, //  操作系统+位数
    resolution: '', //  设备分辨率
    sessionid: window.PAGE_SESSION_ID, // 会话id
    user_id: userInfo.realname || userInfo.uName || '', // 登录用户id
    SN: startInfo.SN,
    isDStore: machineInfo.leas_runtime === 'independent' ? 1 : 0,
    // H5Version: machineInfo.leas_runtime === 'independent' ? `${APP_VERSION_D}_test` : `${APP_VERSION}_test`,
    // ClientVersion: `${startInfo.ClientVersion}_test`,
    H5Version: machineInfo.leas_runtime === 'independent' ? `${APP_VERSION_D}` : `${APP_VERSION}`,
    ClientVersion: startInfo.ClientVersion,
  };

  // 下载应用需要带一些参数
  const installParam = `deviceModel=${encodeURIComponent(
    machineInfo.MT,
  )}&lenovoId=${encodeURIComponent(userInfo.uid || userInfo.lid || '')}&userId=${encodeURIComponent(
    userInfo.realname || userInfo.uName || '',
  )}&sn=${encodeURIComponent(startInfo.SN)}&deviceId=${encodeURIComponent(
    machineInfo.MAC || machineInfo.SN || machineInfo.MACCABLE || machineInfo.UUID || '',
  )}&deviceType=${encodeURIComponent(
    (machineInfo.MAC && 'MAC') ||
      (machineInfo.SN && 'SN') ||
      (machineInfo.MACCABLE && 'MACCABLE') ||
      (machineInfo.UUID && 'UUID') ||
      '',
  )}&clientVersion=${encodeURIComponent(startInfo.ClientVersion)}&appVersion=${encodeURIComponent(
    APP_VERSION,
  )}&appVersionCode=${encodeURIComponent(APP_VERSION_CODE)}`;

  localStorage.setItem(cacheKeys.INSTALL_PARAM, installParam);
  return param1New;
}

export function logInit(machineInfo) {
  window.Avatar &&
    window.Avatar.push({
      appKey: 'L1O38A4LVF13', // 项目appkey，此项目appKey：L1O38A4LVF13
      pageId: 'PC_Store_Register', // 页面标识
      deviceId: machineInfo.MAC || machineInfo.SN || machineInfo.MACCABLE || machineInfo.UUID || '',
      deviceModel: machineInfo.MT, //  设备型号
      versionName: machineInfo.leas_runtime === 'independent' ? APP_VERSION_D : APP_VERSION,
      versionCode:
        machineInfo.leas_runtime === 'independent' ? APP_VERSION_CODE_D : APP_VERSION_CODE,
    });
}

export function logging(info, machineInfo, commandLine) {
  let param1 = assignParam1(info.param1 || {}, machineInfo, commandLine);

  // 特殊处理，如果非Action调用logging，则param1 使用localStroge中的值
  if (!machineInfo && !commandLine) {
    const param1Str = localStorage.getItem(cacheKeys.LOG_PARAM1);
    try {
      param1 = JSON.parse(param1Str);
    } catch (error) {
      logNative(`logging JSON格式错误${error}`, error);
    }
  } else {
    localStorage.setItem(cacheKeys.LOG_PARAM1, JSON.stringify(param1));
  }

  // 获取设备初始信息
  let param4 = {};
  try {
    const startInfo = JSON.parse(localStorage.getItem(cacheKeys.START_INFO));
    param4 = {
      MainLoadEndTime: startInfo.MainLoadEndTime,
      MainLoadStartTime: startInfo.MainLoadStartTime,
      SessionID: startInfo.SessionID,
    };
    if (param4 && param4.MainLoadEndTime && param4.MainLoadStartTime) {
      param4.mainLoadTime =
        parseInt(param4.MainLoadEndTime, 10) - parseInt(param4.MainLoadStartTime, 10);
    }
  } catch (error) {
    logNative(`logging JSON格式错误${error}`, error);
  }

  window.Avatar &&
    window.Avatar.push([
      'track',
      [
        info.category, // 事件的分类名称
        info.action, // 事件分类下的行为名称
        info.label, // 事件的说明
        {
          arg1: JSON.stringify(param1), // 默认为设备信息
          arg2: JSON.stringify(info.param2 || {}), // 页面信息
          arg3: info.param3 || '', // 服务端透传信息bizInfo
          arg4: JSON.stringify(param4 || info.param4 || {}), // sessionID
          arg5: JSON.stringify(info.param5 || {}),
        },
      ],
    ]);
}

/**
 * 前端日志记录console.log 文件记录和云端记录
 * @param {*} method
 * @param {*} params
 */
export const logNative = (method, params, isLogObj, isOnlyLog) => {
  try {
    // 是否console.log打印出数据对象
    if (isLogObj) {
      console.log(`${method}, time: ${+new Date()}`, params);
    } else {
      console.log(`${method}, param: ${JSON.stringify(params || '{}')}, time: ${+new Date()}`);
    }
    // 是否只是console.log，不提交网络请求
    if (isOnlyLog) {
      return;
    }
    // report log
    const ua = window.localStorage.getItem(cacheKeys.USER_TOKEN);
    const token = window.localStorage.getItem(cacheKeys.REGISTER_TOKEN);
    Axios.create()
      .post(REPORT_LOG_URL, {
        time: Date.now(),
        level: 'ERROR',
        serviceName: method,
        whichProduct: 'lenovostore',
        cppversion: '',
        h5version: APP_VERSION,
        useragent: ua,
        headers: token,
        message: `日志信息：${JSON.stringify(params || '{}')}`,
      })
      .catch(error => {
        console.log(`console 提交日志报错:${error.message}`);
      });
  } catch (error) {
    console.log(`console 提交日志报错: logNative went wrong error is ${error.message}`);
  }
};
